/** *****************************
 * Common
 ***************************** */
import { dateShortest, dateShortestLocalized, currency, cdbCount } from "../filters";

export function limitOptions(data) {
  const options = [];

  if (data.length >= 1) options.push(5);
  if (data.length >= 5) options.push(10);
  if (data.length >= 10) options.push(25);
  if (data.length >= 25) options.push(50);
  if (data.length >= 50) options.push(100);
  if (data.length >= 100) options.push(250);
  if (data.length >= 250) options.push(500);
  if (data.length >= 500) options.push(1000);
  if (data.length >= 10) options.push("All");

  return options;
}

export function setPageLimit(recordsPerPage, table, selectedLimitKey) {
  if (recordsPerPage != "All") {
    table.setLimit(recordsPerPage);
  } else {
    table.setLimit(10000000000000000);
  }
  this[selectedLimitKey] = recordsPerPage;
}

export function showMedRec(currentCompany = null) {
   
  const industry = APP_INDUSTRY;
  if (industry == "cannabis" && currentCompany && currentCompany.state && currentCompany.state.display_med_rec_designations) {
    return true;
  }
  return false;
}

export function reportingListPages(subscription) {
  const pages = [];
  if (subscription == "seller") {
    pages.push(
      {
        name: "Basic Seller Orders",
        url: "/reports/basic-seller-orders",
        icon: "fas fa-receipt",
      },
      {
        name: "Product Sales",
        url: "/reports/basic-all-product-sales",
        icon: "fas fa-store-alt",
      },
      {
        name: "Inventory Overview",
        url: "/reports/inventory-overview",
        icon: "fas fa-pallet",
      },
      {
        name: "Samples Report",
        url: "/reports/samples-report",
        icon: "fas fa-boxes",
      },
      {
        name: "Brands Report",
        url: "/reports/brands-report",
        icon: "fas fa-copyright",
      },
    );
  }
  if (subscription == "buyer" || subscription == "seller") {
    pages.push({
      name: "Basic Buyer Orders",
      url: "/reports/basic-buyer-orders",
      icon: "fas fa-dolly-flatbed",
    });
  }
  if (subscription == "seller") {
    pages.push(
      {
        name: "Advanced Seller Orders",
        url: "/reports/seller-orders",
        icon: "fas fa-file-invoice",
      },
      {
        name: "Inventory",
        url: "/reports/current-inventory",
        icon: "fas fa-heartbeat",
      },

      {
        name: "All Product Sales",
        url: "/reports/all-product-sales",
        icon: "fas fa-chart-line",
      },
    );
  }

  if (subscription == "buyer" || subscription == "seller") {
    pages.push({
      name: "Advanced Buyer Orders",
      url: "/reports/buyer-orders",
      icon: "fas fa-file-invoice",
    });
  }

  if (subscription == "seller") {
    pages.push(
      {
        name: "Product Performance",
        url: "/reports/product-performance",
        icon: "fas fa-truck-loading",
      },
      {
        name: "Buyer Performance",
        url: "/reports/buyer-performance",
        icon: "fas fa-user-tag",
      },
      {
        name: "Team Sales",
        url: "/reports/team-sales",
        icon: "fas fa-users",
      },
    );
  }
  return pages;
}

/** *****************************
 * Common Reporting
 ***************************** */

export function setupAgencies(product) {
  let agencies = [];
  if (product.government_agencies.length > 0) {
    product.government_agencies.forEach((agency, agencyIndex) => {
      agencies.push(agency.name);
    });
  }
  if (agencies.length == 0) {
    agencies = null;
  }
  return agencies;
}

export function setupAgenciesAsString(product) {
  let agencies = "";
  if (product.government_agencies.length > 0) {
    product.government_agencies.forEach((agency, agencyIndex) => {
      if (agencyIndex == 0) {
        agencies = agency.name;
      } else {
        agencies = `${agencies} / ${agency.name}`;
      }
    });
  }
  return agencies;
}

export function setupAdditives(product) {
  let additives = [];
  if (product.additives.length > 0) {
    product.additives.forEach((additive, additiveIndex) => {
      additives.push(`(${additive.abbreviation}) ${additive.name}`);
    });
  }
  if (additives.length == 0) {
    additives = null;
  }
  return additives;
}

export function setupAdditivesAsString(product) {
  let additives = "";
  if (product.additives.length > 0) {
    product.additives.forEach((additive, additiveIndex) => {
      if (additiveIndex == 0) {
        additives = `(${additive.abbreviation}) ${additive.name}`;
      } else {
        additives = `${additives} / (${additive.abbreviation}) ${additive.name}`;
      }
    });
  }
  return additives;
}

export function setupItemAdditives(additiveItems) {
  let additives = [];
  if (additiveItems && additiveItems.length > 0) {
    additiveItems.forEach((additive, additiveIndex) => {
      if (additive.abbreviation) {
        additives.push(`(${additive.abbreviation}) ${additive.name}`);
      } else {
        additives.push(`${additive.name}`);
      }
    });
  }
  if (additives.length == 0) {
    additives = null;
  }
  return additives;
}

export function setupItemAdditivesAsString(additiveItems) {
  let additives = "";
  if (additiveItems && additiveItems.length > 0) {
    additiveItems.forEach((additive, additiveIndex) => {
      if (additiveIndex == 0) {
        if (additive.abbreviation) {
          additives = `(${additive.abbreviation}) ${additive.name}`;
        } else {
          additives = `${additive.name}`;
        }
      } else if (additive.abbreviation) {
        additives = `${additives} / (${additive.abbreviation}) ${additive.name}`;
      } else {
        additives = `${additives} / ${additive.name}`;
      }
    });
  }
  return additives;
}

export function setupEnvironmentalIssues(product) {
  let environmentalIssues = [];
  if (product.environmental_issues.length > 0) {
    product.environmental_issues.forEach((environmentalIssue, environmentalIssueIndex) => {
      environmentalIssues.push(environmentalIssue.name);
    });
  }
  if (environmentalIssues.length == 0) {
    environmentalIssues = null;
  }
  return environmentalIssues;
}

export function setupEnvironmentalIssuesAsString(product) {
  let environmentalIssues = "";
  if (product.environmental_issues.length > 0) {
    product.environmental_issues.forEach((environmentalIssue, environmentalIssueIndex) => {
      if (environmentalIssue.name) {
        environmentalIssues = environmentalIssue.name;
      }
    });
  }
  return environmentalIssues;
}

export function quantityLimitedCheck(product) {
  let limitedQuantity = false;
  product.batches.forEach((batch, index) => {
    if (!batch.disable_inventory_tracking) {
      limitedQuantity = true;
    }
  });
  return limitedQuantity;
}

export function showPotencyUnitOfMeasurement(units) {
  const unitString = units.toString().toLowerCase();
  if (unitString == "n/a" || unitString == "not entered") {
    return false;
  }
  return true;
}

export function checkIfAuthorized(user, permission) {
  if (this.userCan(permission, user)) {
    return true;
  }
  return false;
}

export function findTypeName(types, typeId = null) {
  if (typeId) {
    const result = types.find(({ id }) => id === typeId);
    if (result) {
      return result.name;
    }
  }
  return null;
}

export function reportDisplayDateFilter(date) {
  return dateShortest(date);
}

export function reportDisplayDateFilterLocalized(date) {
  return dateShortestLocalized(date);
}

export function setupBatchTerpenes(batch) {
  const terpenesList = [];
  if (batch.terpenes.length > 0) {
    batch.terpenes.forEach((terpene, index) => {
      terpenesList.push(`${terpene.displayName} ${terpene.pivot.measurement}${terpene.pivot.measurement_type}`);
    });
  }
  return terpenesList;
}

export function setupBatchTerpenesAsString(batch) {
  let terpenesList = "";
  if (batch.terpenes.length > 0) {
    batch.terpenes.forEach((terpene, index) => {
      if (index == 0) {
        terpenesList = `${terpene.displayName} ${terpene.pivot.measurement}${terpene.pivot.measurement_type}`;
      } else {
        terpenesList = `${terpenesList} / ${terpene.displayName} ${terpene.pivot.measurement}${terpene.pivot.measurement_type}`;
      }
    });
  }
  return terpenesList;
}

export function setupBatchAdditionalCannabinoids(batch) {
  const cannabinoidsList = [];
  if (batch.additional_cannabinoids.length > 0) {
    batch.additional_cannabinoids.forEach((cannabinoid, index) => {
      cannabinoidsList.push(`${cannabinoid.displayName} ${cannabinoid.pivot.measurement}${cannabinoid.pivot.measurement_type}`);
    });
  }
  return cannabinoidsList;
}

export function parsedLicenses(items) {
  const licenses = [];
  if (items && items.length > 0) {
    items.forEach((item, itemIndex) => {
      if (!licenses.find((l) => l.operation_license == item.operation_license)) {
        licenses.push(item);
      }
    });
  }
  return licenses;
}

export function setupSellerLicenseAsString(items) {
  let licenses = "";
  if (items && items.length > 0) {
    items.forEach((item, itemIndex) => {
      if (item.operation_license) {
        if (licenses.length == 0) {
          licenses = item.operation_license;
        } else {
          licenses = `${licenses} / ${item.operation_license}`;
        }
      }
    });
  }
  return licenses;
}

export function setupBatchAdditionalCannabinoidsAsString(batch) {
  let cannabinoidsList = "";
  if (batch.additional_cannabinoids.length > 0) {
    batch.additional_cannabinoids.forEach((cannabinoid, index) => {
      if (index == 0) {
        cannabinoidsList = `${cannabinoid.displayName} ${cannabinoid.pivot.measurement}${cannabinoid.pivot.measurement_type}`;
      } else {
        cannabinoidsList = `${cannabinoidsList} / ${cannabinoid.displayName} ${cannabinoid.pivot.measurement}${cannabinoid.pivot.measurement_type}`;
      }
    });
  }
  return cannabinoidsList;
}

export function calcBatchPotency(product, batch, category, show = null) {
  let predominateCanabinoid = null;
  let potency = null;
  let returnPotency = null;
  if (category && category.name) {
    potency = cdbCount(batch.predominate_canabinoid_min_or_only, batch.predominate_canabinoid_max, batch.predominate_canabinoid_unit, category.name);
  }
  if (product.predominate_canabinoid_id) {
    predominateCanabinoid = this.additionalCannabinoids.find(({ id }) => id == product.predominate_canabinoid_id);
  }
  if (potency) {
    if (show == "measurement") {
      returnPotency = potency;
    } else if (show == "type") {
      returnPotency = "";
    } else {
      returnPotency = potency;
    }
  }
  if (potency && potency != "N/A" && potency != "Not Entered" && predominateCanabinoid && predominateCanabinoid.abbreviation) {
    if (show == "type") {
      returnPotency = predominateCanabinoid.abbreviation;
    } else if (show != "measurement") {
      returnPotency = `${returnPotency} ${predominateCanabinoid.abbreviation}`;
    }
  }
  return returnPotency;
}

export function paymentStatusBadge(status) {
  if (status) {
    if (status.toLowerCase() == "unpaid") {
      return "badge-danger";
    }
    if (status.toLowerCase() == "partial") {
      return "badge-warning text-white";
    }
    if (status.toLowerCase() == "paid") {
      return "badge-success text-white";
    }
    if (status.toLowerCase() == "completed") {
      return "badge-success text-white";
    }
  }
  return "";
}

export function setupPayments(payments) {
  const self = this;
  const returnPayments = [];
  if (payments && payments.length > 0) {
    payments.forEach((payment, paymentIndex) => {
      returnPayments.push(
        `${payment.type.charAt(0).toUpperCase() + payment.type.slice(1)} of ${self.currency(payment.amount, "$")} on ${self.reportDisplayDateFilter(
          payment.payment_date,
        )}`,
      );
    });
  }
  return returnPayments;
}

export function setupPaymentMethodString(payments) {
  let returnPayments = "";
  if (payments && payments.length > 0) {
    payments.forEach((payment, paymentIndex) => {
      if ((payment.type == "payment" || payment.type == "credit") && payment.pay_type) {
        if (returnPayments.length) {
          returnPayments += ", ";
        }
        returnPayments += payment.pay_type;
      }
    });
  }
  return returnPayments;
}

export function setupPaymentsAsString(payments) {
  const self = this;
  let returnPayments = "";
  if (payments && payments.length > 0) {
    payments.forEach((payment, paymentIndex) => {
      if (paymentIndex == 0) {
        returnPayments = `${payment.type.charAt(0).toUpperCase() + payment.type.slice(1)} of ${currency(
          payment.amount,
          "$",
        )} on ${self.reportDisplayDateFilter(payment.payment_date)}`;
      } else {
        returnPayments =
          `${returnPayments} / ` +
          `${payment.type.charAt(0).toUpperCase() + payment.type.slice(1)} of ${currency(payment.amount, "$")} on ${self.reportDisplayDateFilter(
            payment.payment_date,
          )}`;
      }
    });
  }
  return returnPayments;
}

export function setupSalesReps(reps) {
  const returnReps = [];
  if (reps && reps.length > 0) {
    reps.forEach((rep, repIndex) => {
      returnReps.push(rep.name);
    });
  }
  return returnReps;
}

export function setupSalesRepsString(reps) {
  let returnReps = "";
  if (reps && reps.length > 0) {
    reps.forEach((rep, repIndex) => {
      if (repIndex == 0) {
        returnReps = rep.name;
      } else {
        returnReps = `${returnReps} / ${rep.name}`;
      }
    });
  }
  return returnReps;
}

export function calculateOrdersTotalValue(orders) {
  let total = 0;
  if (orders && orders.length > 0) {
    orders.forEach((order, index) => {
      total += order.total;
    });
  }
  return Number.parseFloat(total);
}

export function calculateAverageOrdersValue(totalValue, totalOrders) {
  let average = 0;
  if (totalValue > 0 && totalOrders > 0) {
    average = parseFloat(totalValue) / parseFloat(totalOrders);
  }
  return Number.parseFloat(average).toFixed(0);
}

export function calculateLastOrderDate(orders) {
  let ordersSorted = [];
  let lastOrderDate = null;
  if (orders && orders.length > 0) {
    ordersSorted = orders.sort((a, b) => new Date(b.order_date) - new Date(a.order_date));
    lastOrderDate = ordersSorted[0].order_date;
  }
  return lastOrderDate;
}

export function calculateTopCategories(orders, limit = null) {
  const categories = [];
  const tempResults = {};
  let results = [];
  if (orders && orders.length > 0) {
    orders.forEach((order) => {
      const orderItems = order.items;
      if (orderItems && orderItems.length > 0) {
        orderItems.forEach((orderItem) => {
          categories.push(orderItem.product_category);
        });
      }
    });
  }
  if (categories && categories.length > 0) {
    categories.forEach(({ name, id }) => {
      tempResults[id] = {
        id,
        name,
        count: tempResults[id] ? tempResults[id].count + 1 : 1,
      };
    });
    results = Object.values(tempResults).sort((a, b) => {
      const lastA = a.count;
      const lastB = b.count;
      return lastA < lastB ? 1 : -1;
    });
    if (limit) {
      results = results.slice(0, limit);
    }
  }
  return results;
}

export function calculateTopTypes(orders, limit = null) {
  const types = [];
  const tempResults = {};
  let results = [];
  if (orders && orders.length > 0) {
    orders.forEach((order) => {
      const orderItems = order.items;
      if (orderItems && orderItems.length > 0) {
        orderItems.forEach((orderItem) => {
          if (orderItem.product_type) {
            types.push(orderItem.product_type);
          }
        });
      }
    });
  }
  if (types && types.length > 0) {
    types.forEach(({ name, id }) => {
      tempResults[id] = {
        id,
        name,
        count: tempResults[id] ? tempResults[id].count + 1 : 1,
      };
    });
    results = Object.values(tempResults).sort((a, b) => {
      const lastA = a.count;
      const lastB = b.count;
      return lastA < lastB ? 1 : -1;
    });
    if (limit) {
      results = results.slice(0, limit);
    }
  }
  return results;
}
export function calcAggregatedTopSellingProducts(type, orderItems, resultsCount = null, calcItemTotal = false) {
  const { length } = orderItems;
  const productIds = [];
  const flags = [];
  let results = [];
  let sorted = [];
  if (orderItems && length > 0) {
    for (let i = 0; i < length; i += 1) {
      if (!flags[orderItems[i].product_id]) {
        flags[orderItems[i].product_id] = true;
        productIds.push(orderItems[i].product_id);
      }
    }
  }
  if (productIds.length > 0) {
    productIds.forEach((productId, productIdIndex) => {
      const currectProducts = orderItems.filter((r) => r.product_id == productId);
      const product = orderItems.find(({ product_id }) => product_id == productId);
      let currectProductsQuantity = 0;
      let currectProductsTotal = parseFloat(0.0);
      let lineTotal = false;

      if (currectProducts.length > 0) {
        currectProducts.forEach((currectProduct, currectProductIndex) => {
          if (currectProduct.order_quantity) {
            currectProductsQuantity += parseFloat(currectProduct.order_quantity);
          }
          if (calcItemTotal) {
            if (currectProduct.order_price / 100 && currectProduct.order_quantity) {
              lineTotal = parseFloat(currectProduct.order_price * currectProduct.order_quantity);
            }
          } else if (currectProduct.line_total_raw) {
            lineTotal = currectProduct.line_total_raw;
          }
          if (lineTotal) {
            currectProductsTotal += parseFloat(lineTotal);
          }
        });
      }
      const hasDecimal = currectProductsQuantity % 1 != 0;
      if (hasDecimal) {
        currectProductsQuantity = currectProductsQuantity.toFixed(2);
      }
      results.push({
        product,
        order_quantity: currectProductsQuantity,
        total: calcItemTotal ? currectProductsTotal : currectProductsTotal * 100,
      });
    });
  }
  if (results.length > 0) {
    if (type == "quantity") {
      sorted = results.sort((a, b) => b.order_quantity - a.order_quantity);
    }
    if (type == "total") {
      sorted = results.sort((a, b) => b.total - a.total);
    }
    if (resultsCount) {
      results = sorted.slice(0, resultsCount);
    }
  }
  return results;
}

export function calculateOrderAverages(orders) {
  let totalOrdersItemsCount = 0;
  let totalOrdersAmount = parseFloat(0.0);
  let averageOrderAmount = 0;
  let averageOrderQuantity = 0;
  let hasDecimal = false;
  if (orders && orders.length > 0) {
    orders.forEach((order, orderIndex) => {
      totalOrdersAmount += parseFloat(order.total);
      totalOrdersItemsCount += order.items.length;
    });
  }
  averageOrderAmount = totalOrdersAmount / orders.length;
  averageOrderQuantity = totalOrdersItemsCount / orders.length;
  hasDecimal = averageOrderAmount % 1 != 0;
  if (hasDecimal) {
    averageOrderAmount = averageOrderAmount.toFixed(0);
  }
  return {
    averageOrderAmount,
    averageOrderQuantity,
  };
}

export function changeOverIcon(newNum, oldNum) {
  const val = this.changeOverPercentage(newNum, oldNum);
  if (val > 0) {
    return "fas fa-fw fa-arrow-up text-success";
  }
  if (val == 0) {
    return "";
  }
  return "fas fa-fw fa-arrow-down text-danger";
}

export function changeArrowPlain(newNum, oldNum) {
  const val = this.changeOverPercentage(newNum, oldNum);
  if (val > 0) {
    return "↑";
  }
  if (val == 0) {
    return "";
  }
  return "↓";
}

export function changeOverTextClass(newNum, oldNum) {
  const val = this.changeOverPercentage(newNum, oldNum);
  if (val > 0) {
    return "text-success";
  }
  if (val == 0) {
    return "";
  }
  return "text-danger";
}

export function changeOverPercentage(newNum, oldNum) {
  const a = parseFloat(newNum.toString().replace(/\$/g, "").toString().replace(/,/g, ""));
  const b = parseFloat(oldNum.toString().replace(/\$/g, "").toString().replace(/,/g, ""));
  if (a == 0 && b == 0) {
    return 0;
  }
  if (b == 0) {
    return 100;
  }
  // if (a == 0) {
  //   a = 1;
  // }
  const c = -(b - a) / b;
  // const d = parseFloat((c * 100).toPrecision(6));
  const d = Math.round((c + Number.EPSILON) * 10000) / 100;
  return d;
}

export function checkAndRound(number, precision = 2) {
  if (Number.isFinite(number)) {
    if (number % 1 != 0) {
      return number.toFixed(precision);
    }
  }
  return number;
}

export function categoryStatuses(industry) {
  const returnObj = {
    flower: true,
    plantMaterial: true,
    prepack: true,
    preroll: true,
    seed: true,
    clone: true,
    bulkExtract: true,
    extract: true,
    cartridge: true,
    merchandise: true,
    ediblesAndDrink: true,
    tincture: true,
    topicalsAndWellness: true,
    packToOrder: true,
  };
  if (industry == "cannabis") {
    returnObj.flower = true;
  }
  return returnObj;
}

export function selectAllCategories(industry) {
  this.categoriesEnabled.flower = true;
  this.categoriesEnabled.plantMaterial = true;
  this.categoriesEnabled.prepack = true;
  this.categoriesEnabled.preroll = true;
  this.categoriesEnabled.seed = true;
  this.categoriesEnabled.clone = true;
  this.categoriesEnabled.bulkExtract = true;
  this.categoriesEnabled.extract = true;
  this.categoriesEnabled.cartridge = true;
  this.categoriesEnabled.merchandise = true;
  this.categoriesEnabled.ediblesAndDrink = true;
  this.categoriesEnabled.tincture = true;
  this.categoriesEnabled.topicalsAndWellness = true;
  this.categoriesEnabled.packToOrder = true;
  this.reportingControls.reportSelected = null;
  if (industry == "cannabis") {
    this.categoriesEnabled.flower = true;
  }
}

export function unSelectAllCategories(industry) {
  this.categoriesEnabled.flower = false;
  this.categoriesEnabled.plantMaterial = false;
  this.categoriesEnabled.prepack = false;
  this.categoriesEnabled.preroll = false;
  this.categoriesEnabled.seed = false;
  this.categoriesEnabled.clone = false;
  this.categoriesEnabled.bulkExtract = false;
  this.categoriesEnabled.extract = false;
  this.categoriesEnabled.cartridge = false;
  this.categoriesEnabled.merchandise = false;
  this.categoriesEnabled.ediblesAndDrink = false;
  this.categoriesEnabled.tincture = false;
  this.categoriesEnabled.topicalsAndWellness = false;
  this.categoriesEnabled.packToOrder = false;
  this.reportingControls.reportSelected = null;
  if (industry == "cannabis") {
    this.categoriesEnabled.flower = false;
  }
}

export function inventoryDataFilterCheck(enabledCategories, data) {
  let filteredData = [];

  // Object.keys(enabledCategories).forEach(key => {
  //   if (!enabledCategories[key]) delete enabledCategories[key];
  // });

  if (enabledCategories.flower == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Flower"));
  }
  if (enabledCategories.plantMaterial == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Plant Material"));
  }
  if (enabledCategories.prepack == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Prepack"));
  }
  if (enabledCategories.preroll == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Preroll"));
  }
  if (enabledCategories.seed == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Seed"));
  }
  if (enabledCategories.clone == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Live Plant"));
  }
  if (enabledCategories.bulkExtract == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Bulk Extract"));
  }
  if (enabledCategories.extract == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Extract"));
  }
  if (enabledCategories.cartridge == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Cartridge"));
  }
  if (enabledCategories.merchandise == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Merchandise"));
  }
  if (enabledCategories.ediblesAndDrink == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Edibles & Drink"));
  }
  if (enabledCategories.tincture == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Tincture"));
  }
  if (enabledCategories.topicalsAndWellness == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Topicals & Wellness"));
  }
  if (enabledCategories.packToOrder == true) {
    filteredData = filteredData.concat(data.filter((arrayItem) => arrayItem.product_category == "Pack To Order"));
  }

  return filteredData;
}

// ? can we replace 'showColumnsCheck' bellow with this? no need to be repetitive, just recursive :P
// Its missing the type which allows it to be overloaded in multiple use types.
export function showColumnsCheck2(rows, enabledColumns) {
  const exclude = [
    "batch_production_date_raw",
    "batch_test_date_raw",
    "batch_created_at_raw",
    "fully_paid_sales_raw",
    "unpaid_sales_raw",
    "partially_paid_sales_raw",
    "write_offs_raw",
    "total_sales_raw",
    "seller_license_display",
    "batch_best_by_date_raw",
    "batch_harvest_date_raw",
    "batch_value_raw",
    "total_raw",
    "product_listing_price_raw",
    "date_of_next_order_of_sampled_raw",
    "next_order_raw",
    "brand_object",
    "key",
    "date_of_sample_order_utc_raw",
    "order",
    "date_of_next_order_raw",
    "date_of_sample_order_localized_raw",
    "surcharges_display",
    "discounts_display",
    "payment_dates_display",
    "quantity_raw",
    "product_total_quantity_raw",
    "product_total_value_raw",
    "product_additives_display",
    "product_environmental_issues_display",
    "product_government_agencies_display",
    "sales_reps_display",
    "batch_additional_cannabinoids_display",
    "batch_terpenes_display",
    "batch_storage_location_display",
    "view_button",
    "buyer_id",
    "product_id",
    "buyer_address_html",
    "product_brand_image",
    "delivery_date_raw",
    "due_date_localized_raw",
    "due_date_utc_raw",
    "order_date_localized_raw",
    "order_date_utc_raw",
    "due_amount_raw",
    "outstanding_amount_raw",
    "group",
  ];

  return rows.map((row) =>
    Object.entries(enabledColumns).reduce((store, [columnKey, columnEnabled]) => {
      if (columnEnabled && !exclude.includes(columnKey)) {
        Object.assign(store, { [columnKey]: row[columnKey] });
      }
      return store;
    }, {}),
  );
}

/* eslint-disable-no-param-reassign */
/* eslint-disable no-constant-binary-expression */

export function showColumnsCheck(columns, columnsEnabled, type) {
  let columnsValue = columns;
  if (!columnsEnabled.uuid) {
    type == "csvExport" ?? (columnsValue = columns.map(({ uuid, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.operation) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "operation"));
    type == "export" ?? delete columnsValue.Operation;
    type == "csvExport" ?? (columnsValue = columns.map(({ operation, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_brand) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_brand"));
    type == "export" ?? delete columnsValue.Brand;
    type == "csvExport" ?? (columnsValue = columns.map(({ product_brand, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_name) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_name"));
    type == "export" ?? delete columnsValue["Product Name"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_name, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_name) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_name"));
    type == "export" ?? delete columnsValue["Batch Name"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_name, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_category) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_category"));
    type == "export" ?? delete columnsValue["Product Category"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_category, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_batch_num) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_batch_num"));
    type == "export" ?? delete columnsValue["Batch Count"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_batch_num, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_sku) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_sku"));
    type == "export" ?? delete columnsValue["Product Sku"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_sku, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_total_quantity) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_total_quantity"));
    type == "export" ?? delete columnsValue["Product Total Quantity"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_total_quantity, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_total_value) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_total_value"));
    type == "export" ?? delete columnsValue["Product Total Value"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_total_value, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_total_value) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_total_value"));
    type == "export" ?? delete columnsValue["Product Total Value"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_total_value, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_total_cost_of_goods) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_total_cost_of_goods"));
    type == "export" ?? delete columnsValue["Product Total Cost of Goods"];
    type == "csvExport" ??
      (columnsValue = columns.map(({ product_total_cost_of_goods, ...cols }) => ({
        ...cols,
      })));
  }
  if (!columnsEnabled.total_cost_of_goods) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_cost_of_goods"));
    type == "export" ?? delete columnsValue["Total Cost of Goods"];
    type == "csvExport" ??
      (columnsValue = columns.map(({ total_cost_of_goods, ...cols }) => ({
        ...cols,
      })));
  }
  if (!columnsEnabled.total) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total"));
    type == "export" ?? delete columnsValue.Total;
    type == "csvExport" ?? (columnsValue = columns.map(({ total, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_listing_price) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_listing_price"));
    type == "export" ?? delete columnsValue["Listing Price"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_listing_price, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_type"));
    type == "export" ?? delete columnsValue["Product Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_type, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_cultivar) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_cultivar"));
    type == "export" ?? delete columnsValue.Cultivar;
    type == "csvExport" ?? (columnsValue = columns.map(({ product_cultivar, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_cultivar_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_cultivar_type"));
    type == "export" ?? delete columnsValue["Cultivar Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_cultivar_type, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_cbd_count) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_cbd_count"));
    type == "export" ?? delete columnsValue["Product Potency"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_cbd_count, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_list_to_buyers) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_list_to_buyers"));
    type == "export" ?? delete columnsValue["Listed to Buyers"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_list_to_buyers, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_list_to_clearinghouse) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_list_to_clearinghouse"));
    type == "export" ?? delete columnsValue["Listed on Clearing House"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_list_to_clearinghouse, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_allow_samples) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_allow_samples"));
    type == "export" ?? delete columnsValue["Samples Allowed"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_allow_samples, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_track_sample_quantity) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_track_sample_quantity"));
    type == "export" ?? delete columnsValue["Samples Tracked"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_track_sample_quantity, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_sample_price) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_sample_price"));
    type == "export" ?? delete columnsValue["Sample Price"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_sample_price, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_sample_size) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_sample_size"));
    type == "export" ?? delete columnsValue["Sample Size"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_sample_size, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_distillate_extract_sub_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_distillate_extract_sub_type"));
    type == "export" ?? delete columnsValue["Distillate Extract Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_distillate_extract_sub_type, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_crude_extract_sub_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_crude_extract_sub_type"));
    type == "export" ?? delete columnsValue["Crude Extract Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_crude_extract_sub_type, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_state_of_material) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_state_of_material"));
    type == "export" ?? delete columnsValue["State of Material"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_state_of_material, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_grow_environment) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_grow_environment"));
    type == "export" ?? delete columnsValue["Grow Environment"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_grow_environment, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_grow_medium) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_grow_medium"));
    type == "export" ?? delete columnsValue["Grow Medium"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_grow_medium, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_drying_method) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_drying_method"));
    type == "export" ?? delete columnsValue["Drying Method"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_drying_method, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_storage_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_storage_type"));
    type == "export" ?? delete columnsValue["Storage Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_storage_type, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_container_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_container_type"));
    type == "export" ?? delete columnsValue["Container Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_container_type, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_trim_method) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_trim_method"));
    type == "export" ?? delete columnsValue["Trim Method"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_trim_method, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_feminized_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_feminized_type"));
    type == "export" ?? delete columnsValue.Feminized;
    type == "csvExport" ?? (columnsValue = columns.map(({ product_feminized_type, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_flowering_period) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_flowering_period"));
    type == "export" ?? delete columnsValue["Flowering Period"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_flowering_period, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_flavor) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_flavor"));
    type == "export" ?? delete columnsValue.Flavor;
    type == "csvExport" ?? (columnsValue = columns.map(({ product_flavor, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_extraction_method) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_extraction_method"));
    type == "export" ?? delete columnsValue["Extraction Method"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_extraction_method, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_infusion_method) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_infusion_method"));
    type == "export" ?? delete columnsValue["Carrier Oil"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_infusion_method, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_government_agencies) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_government_agencies"));
    type == "export" ?? delete columnsValue["Government Registrations"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_government_agencies, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_environmental_issues) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_environmental_issues"));
    type == "export" ?? delete columnsValue["Environmental Issues"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_environmental_issues, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_additives) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_additives"));
    type == "export" ?? delete columnsValue.Additives;
    type == "csvExport" ?? (columnsValue = columns.map(({ product_additives, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_quantity) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_quantity"));
    type == "export" ?? delete columnsValue["Batch Quantity"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_quantity, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_value) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_value"));
    type == "export" ?? delete columnsValue["Batch Value"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_value, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_zone_number) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_zone_number"));
    type == "export" ?? delete columnsValue["Zone Number"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_zone_number, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_lot_number) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_lot_number"));
    type == "export" ?? delete columnsValue["Lot Number"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_lot_number, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_sack_number) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_sack_number"));
    type == "export" ?? delete columnsValue["Sack Number"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_sack_number, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_seeded) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_seeded"));
    type == "export" ?? delete columnsValue.Seeded;
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_seeded, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_harvest_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_harvest_date"));
    type == "export" ?? delete columnsValue["Harvest Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_harvest_date, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_dry_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_dry_date"));
    type == "export" ?? delete columnsValue["Dry Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_dry_date, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_extraction_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_extraction_date"));
    type == "export" ?? delete columnsValue["Extraction Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_extraction_date, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_best_by_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_best_by_date"));
    type == "export" ?? delete columnsValue["Expiration Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_best_by_date, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_production_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_production_date"));
    type == "export" ?? delete columnsValue["Production Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_production_date, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_location) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_location"));
    type == "export" ?? delete columnsValue["Batch Location"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_location, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_thc_limit) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_thc_limit"));
    type == "export" ?? delete columnsValue["THC Limit"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_thc_limit, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_hold) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_hold"));
    type == "export" ?? delete columnsValue["On Deck"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_hold, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_true_hold) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_true_hold"));
    type == "export" ?? delete columnsValue.Hold;
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_true_hold, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_pre_order) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_pre_order"));
    type == "export" ?? delete columnsValue["On Preorder"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_pre_order, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_cbd_count) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_cbd_count"));
    type == "export" ?? delete columnsValue["Batch Potency"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_cbd_count, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_storage_location) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_storage_location"));
    type == "export" ?? delete columnsValue["Storage Location"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_storage_location, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_cost_of_goods) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_cost_of_goods"));
    type == "export" ?? delete columnsValue["Cost of Goods"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_cost_of_goods, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_terpenes) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_terpenes"));
    type == "export" ?? delete columnsValue.Terpenes;
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_terpenes, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.batch_additional_cannabinoids) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_additional_cannabinoids"));
    type == "export" ?? delete columnsValue["Additional Cannabinoids"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_additional_cannabinoids, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_units_per_package) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_units_per_package"));
    type == "export" ?? delete columnsValue["Units Per Package"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_units_per_package, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_units_per_case) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_units_per_case"));
    type == "export" ?? delete columnsValue["Packages Per Case"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_units_per_case, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_gram_per_preroll) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_gram_per_preroll"));
    type == "export" ?? delete columnsValue["Grams Per Preroll"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_gram_per_preroll, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_germination_rate) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_germination_rate"));
    type == "export" ?? delete columnsValue["Germination Rate"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_germination_rate, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_herm_male_rate) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_herm_male_rate"));
    type == "export" ?? delete columnsValue["Feminization Rate"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_herm_male_rate, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_lineage) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_lineage"));
    type == "export" ?? delete columnsValue.Lineage;
    type == "csvExport" ?? (columnsValue = columns.map(({ product_lineage, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_yields_per_acre_outdoor) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_yields_per_acre_outdoor"));
    type == "export" ?? delete columnsValue["Yields Per Acre (Outdoor)"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_yields_per_acre_outdoor, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_per_sq_ft_indoor) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_per_sq_ft_indoor"));
    type == "export" ?? delete columnsValue["Per Sq Ft (Indoor)"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_per_sq_ft_indoor, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_curing_method) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_curing_method"));
    type == "export" ?? delete columnsValue["Curing Method"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_curing_method, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.product_for_pets) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_for_pets"));
    type == "export" ?? delete columnsValue["For Pets"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_for_pets, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.discounts) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "discounts"));
    type == "export" ?? delete columnsValue.Discounts;
    type == "csvExport" ?? (columnsValue = columns.map(({ discounts, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.surcharges) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "surcharges"));
    type == "export" ?? delete columnsValue.Surcharges;
    type == "csvExport" ?? (columnsValue = columns.map(({ surcharges, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.tiered_surcharge) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "tiered_surcharge"));
    type == "export" ?? delete columnsValue["Tiered Surcharge"];
    type == "csvExport" ?? (columnsValue = columns.map(({ tiered_surcharge, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.computed_sale_price) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "computed_sale_price"));
    type == "export" ?? delete columnsValue["Sale Price"];
    type == "csvExport" ?? (columnsValue = columns.map(({ computed_sale_price, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.minimum_sales_price) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "minimum_sales_price"));
    type == "export" ?? delete columnsValue["Minimum Sale Price"];
    type == "csvExport" ?? (columnsValue = columns.map(({ minimum_sales_price, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.quantity) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "quantity"));
    type == "export" ?? delete columnsValue.Quantity;
    type == "csvExport" ?? (columnsValue = columns.map(({ quantity, ...cols }) => ({ ...cols })));

    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "order_quantity"));
    type == "csvExport" ?? (columnsValue = columns.map(({ order_quantity, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.order_quantity) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "order_quantity"));
    type == "export" ?? delete columnsValue.Quantity;
    type == "csvExport" ?? (columnsValue = columns.map(({ order_quantity, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.invoice_note) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "invoice_note"));
    type == "export" ?? delete columnsValue["Invoice Note"];
    type == "csvExport" ?? (columnsValue = columns.map(({ invoice_note, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.weight_unit) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "weight_unit"));
    type == "export" ?? delete columnsValue["Weight/Unit"];
    type == "csvExport" ?? (columnsValue = columns.map(({ weight_unit, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.package_case) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "package_case"));
    type == "export" ?? delete columnsValue["Package/Case"];
    type == "csvExport" ?? (columnsValue = columns.map(({ package_case, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.line_total) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "line_total"));
    type == "export" ?? delete columnsValue["Line Total"];
    type == "csvExport" ?? (columnsValue = columns.map(({ line_total, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.is_sample) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "is_sample"));
    type == "export" ?? delete columnsValue.Sample;
    type == "csvExport" ?? (columnsValue = columns.map(({ is_sample, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.order_number) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "order_number"));
    type == "export" ?? delete columnsValue["Invoice Number"];
    type == "csvExport" ?? (columnsValue = columns.map(({ order_number, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.order_status) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "order_status"));
    type == "export" ?? delete columnsValue["Order Status"];
    type == "csvExport" ?? (columnsValue = columns.map(({ order_status, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.payment_status) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "payment_status"));
    type == "export" ?? delete columnsValue["Payment Status"];
    type == "csvExport" ?? (columnsValue = columns.map(({ payment_status, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.payment_dates) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "payment_dates"));
    type == "export" ?? delete columnsValue.Payments;
    type == "csvExport" ?? (columnsValue = columns.map(({ payment_dates, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.order_date_utc) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "order_date_utc"));
    type == "export" ?? delete columnsValue["Order Date (UTC)"];
    type == "csvExport" ?? (columnsValue = columns.map(({ order_date_utc, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.order_date_localized) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "order_date_localized"));
    type == "export" ?? delete columnsValue["Order Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ order_date_localized, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.delivery_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "delivery_date"));
    type == "export" ?? delete columnsValue["Delivery Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ delivery_date, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_name) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_name"));
    type == "export" ?? delete columnsValue["Buyer Name"];
    type == "export" ?? delete columnsValue["Buyer Name"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_name, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.seller_name) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "seller_name"));
    type == "export" ?? delete columnsValue["Seller Name"];
    type == "csvExport" ?? (columnsValue = columns.map(({ seller_name, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_address) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_address"));
    type == "export" ?? delete columnsValue["Buyer Address"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_address, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_city) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_city"));
    type == "export" ?? delete columnsValue["Buyer City"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_city, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_state) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_state"));
    type == "export" ?? delete columnsValue["Buyer State"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_state, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_zip) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_zip"));
    type == "export" ?? delete columnsValue["Buyer Zip"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_zip, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_country) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_country"));
    type == "export" ?? delete columnsValue["Buyer Country"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_country, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.sales_reps) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "sales_reps"));
    type == "export" ?? delete columnsValue["Sales Reps"];
    type == "csvExport" ?? (columnsValue = columns.map(({ sales_reps, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.view_button) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "view_button"));
    type == "export" ?? delete columnsValue[""];
    type == "export" ?? delete columnsValue[""];
    type == "csvExport" ?? (columnsValue = columns.map(({ view_button, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.order_total) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "order_total"));
    type == "export" ?? delete columnsValue["Order Total"];
    type == "export" ?? delete columnsValue["Order Total"];
    type == "csvExport" ?? (columnsValue = columns.map(({ order_total, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.delivery_cost) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "delivery_cost"));
    type == "export" ?? delete columnsValue["Shipping Cost"];
    type == "export" ?? delete columnsValue["Shipping Cost"];
    type == "csvExport" ?? (columnsValue = columns.map(({ delivery_cost, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.total_discount) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_discount"));
    type == "export" ?? delete columnsValue["Total Discount"];
    type == "export" ?? delete columnsValue["Total Discount"];
    type == "csvExport" ?? (columnsValue = columns.map(({ total_discount, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.custom_order_number) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "custom_order_number"));
    type == "export" ?? delete columnsValue["Custom Invoice Number"];
    type == "csvExport" ?? (columnsValue = columns.map(({ custom_order_number, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.payment_method) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "payment_method"));
    type == "export" ?? delete columnsValue["Payment Method"];
    type == "export" ?? delete columnsValue["Payment Method"];
    type == "csvExport" ?? (columnsValue = columns.map(({ payment_method, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.total_payments) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_payments"));
    type == "export" ?? delete columnsValue["Total Payments"];
    type == "export" ?? delete columnsValue["Total Payments"];
    type == "csvExport" ?? (columnsValue = columns.map(({ total_payments, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.total_credits) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_credits"));
    type == "export" ?? delete columnsValue["Total Credits"];
    type == "export" ?? delete columnsValue["Total Credits"];
    type == "csvExport" ?? (columnsValue = columns.map(({ total_credits, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.total_write_offs) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_write_offs"));
    type == "export" ?? delete columnsValue["Total Write Offs"];
    type == "export" ?? delete columnsValue["Total Write Offs"];
    type == "csvExport" ?? (columnsValue = columns.map(({ total_write_offs, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_term) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_term"));
    type == "export" ?? delete columnsValue["Buyer Term"];
    type == "export" ?? delete columnsValue["Buyer Term"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_term, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.due_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "due_date"));
    type == "export" ?? delete columnsValue["Due Date"];
    type == "export" ?? delete columnsValue["Payment Due Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ due_date, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.due_date_localized) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "due_date_localized"));
    type == "export" ?? delete columnsValue["Payment Due Date"];
    type == "export" ?? delete columnsValue["Payment Due Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ due_date_localized, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.due_date_utc) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "due_date_utc"));
    type == "export" ?? delete columnsValue["Payment Due Date (UTC)"];
    type == "export" ?? delete columnsValue["Payment Due Date (UTC)"];
    type == "csvExport" ?? (columnsValue = columns.map(({ due_date_utc, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.manifest_number) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "manifest_number"));
    type == "export" ?? delete columnsValue["Manifest Number"];
    type == "export" ?? delete columnsValue["Manifest Number"];
    type == "export" ?? delete columnsValue["Manifest #"];
    type == "csvExport" ?? (columnsValue = columns.map(({ manifest_number, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.total_surcharges) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_surcharges"));
    type == "export" ?? delete columnsValue["Total Surcharges"];
    type == "export" ?? delete columnsValue["Total Surcharges"];
    type == "csvExport" ?? (columnsValue = columns.map(({ total_surcharges, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.shipping_method) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "shipping_method"));
    type == "export" ?? delete columnsValue["Shipping Method"];
    type == "export" ?? delete columnsValue["Shipping Method"];
    type == "csvExport" ?? (columnsValue = columns.map(({ shipping_method, ...cols }) => ({ ...cols })));
  }

  // type == 'csvExport' ?? columnsValue = columns.map(({shipping_method,...cols}) => ({...cols}));

  if (!columnsEnabled.seller_license) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "seller_license"));
    type == "export" ?? delete columnsValue["Seller License"];
    type == "csvExport" ?? (columnsValue = columns.map(({ seller_license, ...cols }) => ({ ...cols })));
  }
  if (!columnsEnabled.buyer_license) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "buyer_license"));
    type == "export" ?? delete columnsValue["Buyer License"];
    type == "csvExport" ?? (columnsValue = columns.map(({ buyer_license, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.product_unit) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_unit"));
    type == "export" ?? delete columnsValue["Unit of Measure"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_unit, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.med_rec) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "med_rec"));
    type == "export" ?? delete columnsValue["Med/Rec"];
    type == "csvExport" ?? (columnsValue = columns.map(({ med_rec, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.product_cbd_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_cbd_type"));
    type == "export" ?? delete columnsValue["Product Potency Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_cbd_type, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_cbd_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_cbd_type"));
    type == "export" ?? delete columnsValue["Batch Potency Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_cbd_type, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_cbd_type) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_cbd_type"));
    type == "export" ?? delete columnsValue["Batch Potency Type"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_cbd_type, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_cbd_potency) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_cbd_potency"));
    type == "export" ?? delete columnsValue.Potency;
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_cbd_potency, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.metrc_packages) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "metrc_packages"));
    type == "export" ?? delete columnsValue["Metrc Package"];
    type == "csvExport" ?? (columnsValue = columns.map(({ metrc_packages, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.notes) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "notes"));
    type == "export" ?? delete columnsValue.Notes;
    type == "csvExport" ?? (columnsValue = columns.map(({ notes, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.true_cost) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "true_cost"));
    type == "export" ?? delete columnsValue["True Cost"];
    type == "csvExport" ?? (columnsValue = columns.map(({ true_cost, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.industry) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "industry"));
    type == "export" ?? delete columnsValue.Industry;
    type == "csvExport" ?? (columnsValue = columns.map(({ industry, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.fully_paid_sales) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "fully_paid_sales"));
    type == "export" ?? delete columnsValue["Fully Paid Sales"];
    type == "csvExport" ?? (columnsValue = columns.map(({ fully_paid_sales, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.unpaid_sales) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "unpaid_sales"));
    type == "export" ?? delete columnsValue["Unpaid Sales"];
    type == "csvExport" ?? (columnsValue = columns.map(({ unpaid_sales, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.partially_paid_sales) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "partially_paid_sales"));
    type == "export" ?? delete columnsValue["Partially Paid Sales"];
    type == "csvExport" ?? (columnsValue = columns.map(({ partially_paid_sales, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.write_offs) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "write_offs"));
    type == "export" ?? delete columnsValue["Write Offs"];
    type == "csvExport" ?? (columnsValue = columns.map(({ write_offs, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.product_unit_size_and_measurement) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_unit_size_and_measurement"));
    type == "export" ?? delete columnsValue["Unit Size/Weight"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_unit_size_and_measurement, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_created_at) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_created_at"));
    type == "export" ?? delete columnsValue["Batch Created"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_created_at, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_test_date) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_test_date"));
    type == "export" ?? delete columnsValue["Test Date"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_test_date, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_true_cost) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_true_cost"));
    type == "export" ?? delete columnsValue["True Cost"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_true_cost, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.product_minimum_sales_price) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "product_minimum_sales_price"));
    type == "export" ?? delete columnsValue["Minimum Sales Price"];
    type == "csvExport" ?? (columnsValue = columns.map(({ product_minimum_sales_price, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.due_amount) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "due_amount"));
    type == "export" ?? delete columnsValue.Due;
    type == "csvExport" ?? (columnsValue = columns.map(({ due_amount, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.outstanding_amount) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "outstanding_amount"));
    type == "export" ?? delete columnsValue.Outstanding;
    type == "csvExport" ?? (columnsValue = columns.map(({ outstanding_amount, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.total_write_off_amount) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_write_off_amount"));
    type == "export" ?? delete columnsValue["Write Offs"];
    type == "csvExport" ?? (columnsValue = columns.map(({ total_write_off_amount, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.total_write_off_amount) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "total_write_off_amount"));
    type == "export" ?? delete columnsValue["Write Offs"];
    type == "csvExport" ?? (columnsValue = columns.map(({ total_write_off_amount, ...cols }) => ({ ...cols })));
  }

  if (!columnsEnabled.batch_metrc_packages) {
    type == "display" ?? (columnsValue = columns.filter((arrayItem) => arrayItem !== "batch_metrc_packages"));
    type == "export" ?? delete columnsValue["Metrc Packages"];
    type == "csvExport" ?? (columnsValue = columns.map(({ batch_metrc_packages, ...cols }) => ({ ...cols })));
  }

  // Stuff we dont export ever
  type == "csvExport" ??
    (columnsValue = columns.map(
      ({
        due_amount_raw,
        outstanding_amount_raw,
        batch_production_date_raw,
        batch_test_date_raw,
        batch_created_at_raw,
        fully_paid_sales_raw,
        unpaid_sales_raw,
        partially_paid_sales_raw,
        write_offs_raw,
        total_sales_raw,
        seller_license_display,
        batch_best_by_date_raw,
        batch_harvest_date_raw,
        batch_value_raw,
        total_raw,
        product_listing_price_raw,
        date_of_next_order_of_sampled_raw,
        next_order_raw,
        brand_object,
        key,
        date_of_sample_order_utc_raw,
        order,
        date_of_next_order_raw,
        date_of_sample_order_localized_raw,
        surcharges_display,
        discounts_display,
        payment_dates_display,
        quantity_raw,
        product_total_quantity_raw,
        product_total_value_raw,
        product_additives_display,
        product_environmental_issues_display,
        product_government_agencies_display,
        sales_reps_display,
        batch_additional_cannabinoids_display,
        batch_terpenes_display,
        batch_storage_location_display,
        view_button,
        buyer_id,
        product_id,
        buyer_address_html,
        product_brand_image,
        delivery_date_raw,
        due_date_localized_raw,
        due_date_utc_raw,
        order_date_localized_raw,
        order_date_utc_raw,
        group,
        ...cols
      }) => ({ ...cols }),
    ));

  return columnsValue;
}
/* eslint-enable-no-param-reassign */

export function sanitizeTheHands(
  value = null,
  removeCommas = true,
  removeLineBreaks = true,
  removeSemiColons = true,
  removeColons = true,
  removePound = true,
) {
  return value;
}

export function sanitizeTheInput(
  value = null,
  removeCommas = true,
  removeLineBreaks = true,
  removeSemiColons = true,
  removeColons = true,
  removePound = true,
) {
  if (value) {
    if (removeCommas) {
      value = value.toString().replace(/,/g, "");
    }
    if (removeLineBreaks) {
      value = value.toString().replace(/[\r\n]+/gm, "");
    }
    if (removeSemiColons) {
      value = value.toString().replace(";", "");
    }
    if (removeColons) {
      value = value.toString().replace(":", "");
    }
    if (removePound) {
      value = value.toString().replace("#", "");
    }
  }
  return value;
}
